module.exports = __webpack_public_path__ + "static/media/ic_award_canvas.0c901806.svg";